<h2 mat-dialog-title>
  <span>Select an <span class="text-uppercase">{{ data.mode }}</span> record</span>
</h2>
<mat-dialog-content>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <mat-list *ngFor="let business of data.results" class="abn-list">
          <mat-list-item>
            <div class="row">
              <div class="col-6 ps-3">
                {{business['match-name']['_text']}}
              </div>
              <div class="col-3">
                {{
                data.mode === 'abn' ?
                business['australian-business-number']['_text'] :
                business['australian-company-number']['_text']
                }}
              </div>
              <div class="col-1">
                {{business['state'] ? business['state']['_text'] : ''}}
              </div>
              <div class="col-2">
                <button mat-raised-button color="primary" type="button" [mat-dialog-close]="business">Select</button>
              </div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>

        <div *ngIf="data.results?.length < 1">
          <mat-divider></mat-divider>
          <h5>No matching records found.</h5>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">Close</button>
</mat-dialog-actions>
